export const FORM_CONSTANTS = {
  BREADCRUMB: {
    TITLE: "CCM Quarterly Bonus Form",
    PATH: "/CCM",
  },
  HEADER: {
    TITLE: "CCM Quarterly Bonus Form",
    SUBTITLE:
      "Achievement of Targets is a subjective determination in the Employer's sole discretion. The Employer may change the percentages or Targets at any time.",
  },
  LAYOUT: {
    MAX_WIDTH: "max-w-9xl",
    PADDING: "px-2",
  },
  SECTIONS: {
    CUSTOMER_EXPERIENCE: {
      TITLE: "CUSTOMER EXPERIENCE",
      COLOR: "bg-orange-500",
      SUBSECTIONS: {
        CUSTOMER_CARE_CALLS: {
          TITLE: "Customer Care Calls",
          WEIGHT: "70% of total achievement score",
          NOTE: "This will be evaluated from calls completed within 7 days. The goal is 70% of all calls completed within 7 days.",
        },
      },
    },
    BONUS_CALCULATION: {
      TITLE: "BONUS CALCULATION",
      COLOR: "bg-orange-500",
    },
  },
  PAYOUT_TIERS: {
    CUSTOMER_CARE_CALLS: [
      { actual: "70%", payout: "100%" },
      { actual: "66%", payout: "95%" },
      { actual: "63%", payout: "90%" },
      { actual: "56%", payout: "80%" },
      { actual: "50%", payout: "50%" },
      { actual: "49% or less", payout: "0%" },
    ],
  },
  OPS: {
    NAME: "Angie Hayes",
    EMAIL: "Angie.Hayes@highlandhomes.com",
  }
};
